import axios from "axios";
import { CHECKOUT_BASE } from "../../config/env";

export const FETCH_DELETEBASKET_FULFILLED = "FETCH_DELETEBASKET_FULFILLED";
export const FETCH_DELETEBASKET_REJECTED = "FETCH_DELETEBASKET_REJECTED";
export const FETCH_DELETEBASKET_PENDING = "FETCH_DELETEBASKET_PENDING";
export const RESET_DELETEBASKET = "RESET_DELETEBASKET";

export function deleteBasket(itemId) {
  const token = localStorage.getItem("accessToken");
  return (dispatch) => { 
    dispatch({
      type: "FETCH_DELETEBASKET",
      payload: axios({
        method: "get",
        url: `${CHECKOUT_BASE}/gate/cart/remove/lineItemId=${itemId}`,
        headers: {
          Authorization: "Bearer " + token,
          "Accept-Language": "tr-tr",
          "Content-Type": "application/json",
          "Cart-Type": "fast-checkout"
        },
      }).then((result) => result.data),
    });
  };
}

export function resetDeleteBasket() {
  return (dispatch) => {
    dispatch({
      type: "RESET_DELETEBASKET",
    });
  };
}
